export const SET_DEPENDENTS = 'Set dependents'
export const DELETE_DEPENDENTS = 'Delete dependents'
export const UPDATE_DEPENDENTS = 'Update dependents'
